export const setIsFetching = (state) => {
  return {
    ...state,
    isFetching: true
  }
};

export const filterSearchResult = (state, data) => {
  return {
    ...state,
    isFetching: false,
    // currentPage: data.currentPage > 0 ? data.currentPage : 1,
    totalPage: data.totalPage ?  data.totalPage : 1,
    searchData: data.items,
    errorMessage: null,
  }
};

export const resetSearchResult = (state, message) => {
  return {
    ...state,
    isFetching: false,
    currentPage: 1,
    totalPage: 1,
    searchData: [],
    errorMessage: message,
  }
};

export const filterSearchNavResult = (state, data) => {
  return {
    ...state,
    isFetching: false,
    navs: data
  }
};

export const resetSearchNavResult = (state, message) => {
  return {
    ...state,
    isFetching: false,
    navs: [],
    errorMessage: message,
  }
};

export const checkExistedCategory = (categoryCode, userCategories) => {
  if (userCategories.some((obj) => obj.categoryCode === categoryCode)) {
    return true;
  } else {
    return false;
  }
};

export const updateCurrentPage = (state, page) => {
  return {
    ...state,
    currentPage: page ? page : 1,
  }
};

export const setDefaultQueriesAdvanceSearch = (state, data) => {
	const result = {
		...state,
		categoryCode: [],
		dividendPolicy: data.dividendPolicy[0].code,
		fundTypes: data.fundTypes.map(item => item.code),
		investorRatings : data.investorRatings.map(item => item.code),
		purchaseFee : data.purchaseFee[0].code,
		currencyPolicy : data.currencyPolicy[0].code,
		riskLevels : data.riskLevels.map(item => item.code),
		morningStarRatings: data.morningStarRatings.map(item => item.code),
		company: data.company.map(item => item.id),
		indexFund: true
	};
	return result;
};
